import TimerIcon from '@mui/icons-material/Timer';
import TagFacesIcon from '@mui/icons-material/TagFaces';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';

import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from 'react-router-dom'; 
import { TextField, Box, Typography, CircularProgress } from "@mui/material";
import TokenContext from './TokenContext';
import Carousel from './Carousel';
import { useSnackbar } from 'notistack';
import widgetApi from '../api/WidgetApi';
import { Grid, Card, CardMedia, CardContent, CardActionArea } from '@mui/material';


function Carousels({ countryCode }) {
  const navigate = useNavigate(); 
  const { token, setToken } = useContext(TokenContext);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [widgets, setWidgets] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [selectedWidget, setSelectedWidget] = useState(null);
  const { enqueueSnackbar } = useSnackbar();
  const [hoverStates, setHoverStates] = useState({});



  useEffect(() => {
    fetchWidgets(countryCode);
  }, [countryCode]);

  const fetchWidgets = async (countryIsoCode) => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const carousels = await widgetApi.getCarousels(countryIsoCode, token);

      setWidgets(sortCarousels(carousels));
    } catch (error) {
      if (error.response && error.response.status === 401) {
        enqueueSnackbar('Session expired: Please re-login to continue', { variant: 'info' });
        handleLogout();
      } else {
        enqueueSnackbar('Error fetching carousels: ' + error.message, { variant: 'error' });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    setToken(null);
    localStorage.removeItem('token');
    navigate('/'); 
  };

  const updateCarousel = (updatedCarousel) => {
    const newCarousels = widgets.map(carousel =>
      carousel.id === updatedCarousel.id ? updatedCarousel : carousel
    );
    setWidgets(newCarousels);
  };

  const sortCarousels = carousels => {
    return carousels.sort((a, b) => {
      if (a.enabled === b.enabled) {
        return 0;
      }
      return a.enabled ? -1 : 1;
    });
  }

  const handleOpenCarousel = (event, widget) => {
    event.stopPropagation();
    setSelectedWidget(widget);
    setOpen(true);
  };

 
  const handleCloseCarousel = () => {
    setSelectedWidget(null);
  };

  const handleCarouselSearchChange = (event) => {
    setSearchValue(event.target.value);
  };

  const filteredWidgets = widgets.filter((widget) =>
    widget.id.toLowerCase().includes(searchValue.toLowerCase())
    || widget.name.toLowerCase().includes(searchValue.toLowerCase())  
  );

  return (
    <Box display="flex" flexDirection="column" alignItems="flex-end" style={{ backgroundColor: "white", padding: "2rem", minHeight: "100vh" }}>
      <Box display="flex" justifyContent="flex-end" style={{ width: '30%', marginBottom: "1rem" }}>
        <TextField
          fullWidth
          label="Search by ID or name"
          variant="outlined"
          value={searchValue}
          onChange={handleCarouselSearchChange}
          style={{ marginBottom: "1rem", maxWidth: "67%",  margin: "auto auto",}}
        />
      </Box>
      <Grid container spacing={3} style={{ maxWidth: "90%", margin: "0 auto", backgroundColor: "#F7F8F9" }}>
        {loading ? (
          <Grid item xs={12} style={{ textAlign: 'center' }}>
            <CircularProgress />
          </Grid>
        ) : (
          filteredWidgets.map((widget) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={widget.id}>
            <Card className="zoomCard"
              style={{
                transition: 'transform 0.3s, boxShadow 0.3s, backgroundColor 0.3s',
                boxShadow: hoverStates[widget.id] ? '0 8px 16px rgba(0,0,0,0.1)' : '0 4px 8px rgba(0,0,0,0.06)',
                backgroundColor: hoverStates[widget.id] ? 'rgba(255, 255, 255, 0.98)' : 'rgba(255, 255, 255, 1)',
              }}
              onMouseEnter={() => setHoverStates(prev => ({ ...prev, [widget.id]: true }))}
              onMouseLeave={() => setHoverStates(prev => ({ ...prev, [widget.id]: false }))}
            >
            <CardActionArea onClick={(event) => handleOpenCarousel(event, widget)}>
              <div style={{ position: 'relative' }}>
                <CardMedia
                  component="img"
                  alt="Imagen del carousel"
                  image="https://rappi-images-upload-co.s3.amazonaws.com/home-ab-objects/carousel_simple.png"
                  title="Imagen del Carousel"
                  style={{
                    height: '140px',
                    objectFit: 'cover',
                  }}
                />
                <div style={{
                  position: 'absolute',
                  bottom: '0', 
                  left: '0',
                  width: '100%',
                  background: 'rgba(0, 0, 0, 1)',
                  color: 'white',
                  padding: '10px 0', 
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '12px', 
                }}>
                  {widget.name}
                </div>
              </div>
              <CardContent>
                <Typography variant="body2" color="textSecondary" component="p" align="center">
                  <span style={{ marginRight: '0.5rem' }}>
                    {widget.enabled ? 
                      <><ToggleOnIcon style={{ fontSize: '0.75rem' }} /> Enabled</> : 
                      <><ToggleOffIcon style={{ fontSize: '0.75rem' }} /> Disabled</>
                    }
                  </span>
                  <span style={{ marginRight: '0.5rem' }}>
                    <><TimerIcon style={{ fontSize: '0.75rem' }} /> {widget.param.start_hour}h - {widget.param.end_hour}h</>
                  </span>
                  <span style={{ marginRight: '0.5rem' }}>
                    <><TagFacesIcon style={{ fontSize: '0.75rem' }} /> {widget.param.user_tags.length > 0 ? widget.param.user_tags.length +' tag' : 'All users'}</>
                  </span>
                  <span>
                    <><CalendarTodayIcon style={{ fontSize: '0.75rem' }} /> {(widget.param.days.length > 0 && widget.param.days.length != 7)  ? widget.param.days.length + ' days' : 'All days'}</>
                  </span>
                </Typography>
              </CardContent>
            </CardActionArea>
              </Card>
            </Grid>
          ))
        )}
      </Grid>



      {selectedWidget && (
        <Carousel
          open={Boolean(selectedWidget)}
          widget={selectedWidget}
          onUpdate={updateCarousel}
          onClose={handleCloseCarousel}
          token={token}
          countryCode={countryCode}
        />
      )}
    </Box>
  );
}

export default Carousels;


